/*
 Licensed Materials - Property of IBM
 5737-I23
 Copyright IBM Corp. 2019. All Rights Reserved.
 U.S. Government Users Restricted Rights:
 Use, duplication or disclosure restricted by GSA ADP Schedule
 Contract with IBM Corp.
 */

import { CustomFieldTemplate } from './CustomFieldTemplate';
import { CustomObjectFieldTemplate } from './CustomObjectFieldTemplate';
import { CustomArrayFieldTemplate } from './CustomArrayFieldTemplate';

export const templates = {
    FieldTemplate: CustomFieldTemplate,
    ObjectFieldTemplate: CustomObjectFieldTemplate,
    ArrayFieldTemplate: CustomArrayFieldTemplate
};